import { render, staticRenderFns } from "./LichSuDichVuVeDienTuList.vue?vue&type=template&id=48dd509a"
import script from "./LichSuDichVuVeDienTuList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuVeDienTuList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuVeDienTuList.vue?vue&type=style&index=0&id=48dd509a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports